import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { className: "layout-container" }
const _hoisted_2 = { class: "stretch-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sandpack_navigation = _resolveComponent("sandpack-navigation")!
  const _component_sandpack_code_editor = _resolveComponent("sandpack-code-editor")!
  const _component_sandpack_layout = _resolveComponent("sandpack-layout")!
  const _component_loading = _resolveComponent("loading")!
  const _component_sandpack_preview = _resolveComponent("sandpack-preview")!
  const _component_console_icon = _resolveComponent("console-icon")!
  const _component_sandpack_console = _resolveComponent("sandpack-console")!
  const _component_sandpack_provider = _resolveComponent("sandpack-provider")!

  return (_openBlock(), _createBlock(_component_sandpack_provider, {
    style: {
      height: '100%',
      position: 'relative',
    },
    template: _ctx.frame,
    options: {
      externalResources: [
        'https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js',
        `https://g.alicdn.com/sail-fe/alibaba-lyj-js-player-umd/1.1.5/editor.js`,
        `https://g.alicdn.com/sail-fe/alibaba-lyj-js-player-umd/1.1.5/plugin.js`,
      ],
      recompileMode: `delayed`,
      recompileDelay: 2000,
    },
    customSetup: {
      entry: '/index.js',
      dependencies: {
        react: 'latest',
        // 'react-dom': 'latest',
      },
    },
    files: {
      ..._ctx.files,
      ..._ctx.codeMap?.defaultFile,
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_sandpack_layout, {
          style: _normalizeStyle({
          flex: 0.5,
        })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_sandpack_navigation, {
              codeMap: _ctx.codeMap,
              onGetLoading: _ctx.getLoading
            }, null, 8, ["codeMap", "onGetLoading"]),
            _createVNode(_component_sandpack_code_editor, {
              style: {
            height: '100%',
          },
              showTabs: "",
              showLineNumbers: "",
              showInlineErrors: "",
              wrapContent: false,
              closableTabs: false,
              readOnly: false,
              showReadOnly: false,
              showRunButton: ""
            })
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_sandpack_layout, {
          style: _normalizeStyle({
          flex: 0.5,
          display: 'flex',
          flexDirection: 'column',
          background: 'white',
          flexWrap: 'nowrap',
        })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "preview-wrap",
              style: _normalizeStyle({
            flex: _ctx.consoleVisible ? 0.75 : 1,
            transition: 'all 0.3s',
          })
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_sandpack_preview, {
                id: _ctx.codeMap?.refName,
                showOpenInCodeSandbox: false,
                style: {
              height: '100%',
            },
                "show-refresh-button": false
              }, null, 8, ["id"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "stretch-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchConsole && _ctx.switchConsole(...args)))
                }, [
                  _createVNode(_component_console_icon)
                ])
              ])
            ], 4),
            _createElementVNode("div", {
              class: "console-wrap",
              style: _normalizeStyle({
            flex: _ctx.consoleVisible ? 0.2 : 0,
            transition: 'all 0.3s',
          })
            }, [
              _createVNode(_component_sandpack_console, { showHeader: false })
            ], 4)
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ]),
    _: 1
  }, 8, ["template", "options", "customSetup", "files"]))
}